import { IFormConfigurationService } from "../../service/formconfiguration/FormConfigurationService";

export default class GetFormConfigDetailsInteractor {
  private formConfigurationService: IFormConfigurationService;

  constructor(formConfigurationService) {
    this.formConfigurationService = formConfigurationService;
  }

  async execute(formTypeCode: string) {
    return this.formConfigurationService.getFormConfigurationDetails(
      formTypeCode
    );
  }
}
